<div class="errorContainer">
  <div class="errorIcon">
    <vc-sprite-icons name="issue"></vc-sprite-icons>
  </div>
  <div class="errorTitle vc-text-m" i18n="@@GET_PAID.ERROR.TITLE">Something went wrong !</div>
  <div class="errorText vc-text-m" i18n="@@GET_PAID.ERROR.DESCRIPTION">
    Server is down, please check again later.
  </div>
  <div class="errorEnd vc-text-l" i18n="@@GET_PAID.ERROR.REGARDS">Thank you!</div>
</div>
